import React from "react";

const PedicureNearMeOption = () => {
  return (
    <div className="hairSalonNearMeService">
      <h3>The Benefits of a Pedicure</h3>
      <p>
        We understand that every individual has unique needs when it comes to
        foot care. That’s why we offer a variety of pedicure services, ensuring
        that your search for pedicure near me ends with the perfect treatment
        for you:
      </p>

      <li>
        <h6>1.	Classic Pedicure</h6>
        <p>
           Ideal for those seeking a simple yet effective treatment, the
          classic pedicure includes nail shaping, cuticle care, exfoliation, and
          a hydrating massage.
        </p>
      </li>
      <li>
        <h6> 2.	Spa Pedicure</h6>
        <p>
           A step up from the classic, our spa pedicure incorporates aromatic
          scrubs, masks, and advanced moisturizing treatments.
        </p>
      </li>
      <li>
        <h6>3.	Gel Pedicure</h6>
        <p>
           For long-lasting, chip-resistant nail polish, our gel pedicure is
          the perfect choice.
        </p>
      </li>
      <li>
        <h6>4. Therapeutic Pedicure</h6>
        <p>
           Designed for individuals with foot issues like corns, calluses, or
          dry skin, this pedicure focuses on healing and restoring foot health.
        </p>
      </li>
    </div>
  );
};

export default PedicureNearMeOption;
